<template>
  <div class="d-flex flex-column" style="height: 100%">
    <!-- <div class="row justify-content-start py-2 flex-wrap m-0">
      <div class="d-flex align-items-center mx-4" style="cursor: pointer" @click="GoAction('')">
        <b-icon icon="arrow-return-left" flip-v></b-icon>
        <label class="m-0 event_label" style="cursor: pointer">回上頁</label>
      </div>
    </div> 
    <div class="row justify-content-between py-2 flex-wrap m-0 cust_sec_head">
      <div class="d-flex align-items-center">
        <label class="m-0 ml-4" style="font-size: 2rem; color: #ff5c00; font-weight: bolder">訂餐系統</label>
      </div>
      <div class="d-flex align-items-center mx-4">
        <label class="m-0 cust_sec_head_label" style="cursor: pointer" @click="GoAction('MealOrderRecord')">訂餐紀錄</label>
        <label class="cust_sec_head_label mx-2">|</label>
        <label class="m-0 cust_sec_head_label" style="cursor: pointer" @click="GoAction('MainPage')">訂位紀錄</label>
      </div>
    </div>-->
    <div class="flex-grow-1 Main_css">
      <div class="col-12 row m-0 justify-content-around h-100 p-0">
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>
<script>
import checkLoginMixin from '@/mixins/checkLoginMixin';
export default {
  name: 'Home',
  components: {},
  data() {
    return {
      SuplNO: ''
    };
  },
  watch: {},
  mixins: [checkLoginMixin],
  mounted() {
    this.init();
    // this.checktoken();
    // this.GetUserInfo();
    // this.GoAction('OrderOrReservation');
  },
  methods: {
    async init() {
      // await this.checktoken();
      // await this.GetUserInfo();
      this.GoAction('OrderOrReservation');
    },
    GoAction(name) {
      if (name == '') {
        if (this.$route.name == 'OrderOrReservation') {
          name = 'MainPage';
        }
        if (this.$route.name == 'MealMenu') {
          name = 'OrderOrReservation';
          // this.$router.push({
          //   name: name,
          //   query: { value: this.$route.query.value }
          // });
          //return;
        }
        if (this.$route.name == 'Restaurant') {
          name = 'OrderOrReservation';
        }
        if (this.$route.name == 'MealOrderRecord') {
          name = 'OrderOrReservation';
        }
        if (this.$route.name == 'MealCustom') {
          name = 'OrderOrReservation';
        }
      }
      //return
      this.$router.push({
        name: name
      });
    },
    Msg(msg, sec, type) {
      this.$parent.Msg(msg, sec, type);
    }
  }
};
</script>
<style scoped>
.event_count_label_g {
  border-radius: 6px;
  margin: 0 !important;
  font-size: 1rem;
  background-color: #69a835;
  color: white;
  font-weight: 600;
  padding: 2px 8px 2px 8px;
}

.event_count_label_r {
  border-radius: 6px;
  margin: 0 !important;
  font-size: 1rem;
  background-color: #c62e67;
  color: white;
  font-weight: 600;
  padding: 2px 8px 2px 8px;
}

.event_label {
  margin-left: 10px !important;
  font-size: 1.5rem;
  color: #a37e5c;
  font-weight: 600;
}

.Main_css {
  background-color: #faf7f2;
}

.cust_card_icon {
  width: 65px;
  height: 65px;
}

.cust_card {
  /* padding: 15px 50px 15px 50px; */
  border: 1px solid white;
  background-color: white;
  border-radius: 0.5rem;
  box-shadow: 1px 1px 1px 1px #cbb79a;
  height: 200px;
  width: 100%;
  max-width: 400px;
  cursor: pointer;
}

.cust_page_btn {
  height: 45px;
  width: 30px;
  padding: 0;
  justify-content: center;
  background-color: #ec6c01;
  border: #ec6c01;
}

.cust_sec_head {
  background: linear-gradient(to right, #fcedd0, white);
}

.cust_sec_head_label {
  font-size: 1.5rem;
  color: #a37e5c;
}
</style>



// WEBPACK FOOTER //
// src/components/View/Meal/MealOrderMain.vue